import { createFileRoute } from "@tanstack/react-router";
import type { FoodSensorySessionId } from "@brewbase/db/types";
import { HostStage, type StageMode } from "@/external/tasting/HostStage";
import { signalPreviewReady } from "@/external/tasting/preview-room";

const MODES: StageMode[] = ["stage", "window", "now", "next"];

/** A tasting's stage: on its own, popped out of the presenter's screen (`window`), or one of its mirrors (`now`, `next`). */
export const Route = createFileRoute("/stage/tasting/$tasting_id")({
  component: RouteComponent,
  parseParams: (params) => ({
    tasting_id: parseInt(params.tasting_id, 10),
  }),
  validateSearch: (search: Record<string, unknown>): { mode?: StageMode } => ({
    mode: MODES.find((m) => m === search.mode),
  }),
});

function RouteComponent() {
  const { tasting_id } = Route.useParams();
  const { mode } = Route.useSearch();
  const mirror = mode === "now" || mode === "next";
  return (
    <>
      <HostStage tastingId={tasting_id as FoodSensorySessionId} mode={mode} />
      {/* A mirror tells the presenter's frame it drew, as the editor's preview frames do. */}
      {mirror && <span hidden ref={signalPreviewReady} />}
    </>
  );
}
